/* THIS FILE IS GENERATED. DO NOT EDIT IT. */
import * as React from 'react';

function SvgBell(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={24}
      height={24}
      fill='none'
      viewBox='0 0 24 24'
      {...props}
    >
      <path
        fill='currentColor'
        fillRule='evenodd'
        d='M7.227 3.229A6.75 6.75 0 0118.75 8.002c0 3.39.725 5.513 1.408 6.766.343.628.68 1.044.918 1.296a3.277 3.277 0 00.338.312l.009.006a.75.75 0 01-.423 1.37H3a.75.75 0 01-.423-1.37l.009-.006.063-.05c.06-.05.156-.136.275-.262.239-.252.575-.668.918-1.296.683-1.253 1.408-3.377 1.408-6.766a6.75 6.75 0 011.977-4.773zM4.69 16.252h14.62a8.758 8.758 0 01-.468-.766c-.817-1.498-1.592-3.874-1.592-7.484a5.25 5.25 0 10-10.5 0c0 3.61-.775 5.986-1.592 7.484a8.783 8.783 0 01-.468.766zm5.204 4.101a.75.75 0 011.025.272 1.25 1.25 0 002.162 0 .75.75 0 111.298.753 2.75 2.75 0 01-4.758 0 .75.75 0 01.273-1.025z'
      />
    </svg>
  );
}

export default SvgBell;
